import { useGetTournamentQuery } from '@slope/graphql/apollo';
import { Clock } from '@slope/uikit';
import React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem;
  gap: 1rem;
  align-items: center;

  @media (max-width: 768px) {
    & {
      flex-direction: column;
      align-items: flex-start;
    }

    & .clock {
      font-size: 2rem;
    }
  }
`;

const Title = styled.h3`
  font-size: 2rem;
  font-weight: 400;
  margin: 0;
  text-transform: capitalize;
  font-family: 'PP Neue Montreal Book', sans-serif;

  line-height: 2rem;

  & > small {
    font-size: 1rem;
    font-weight: normal;
    color: #666;
  }

  @media (max-width: 768px) {
    & {
      font-size: 1.5rem;
    }
  }
`;

const Order = styled.div`
  font-size: 0.87rem;
  color: #de1a1a;
  padding: 0 0.5rem;
  background: #abff4f;
  color: black;
  border-radius: 0 0.5rem 0.5rem 0.5rem;
  background: #c6a95d;
  color: white;
  display: inline-flex;
  align-items: anchor-center;
  font-family: 'PP Neue Montreal Book', sans-serif;
`;

const Flex = styled.div.withConfig({
  shouldForwardProp: (prop) => !['direction'].includes(prop),
})<{
  direction?: 'row' | 'column';
}>`
  display: flex;
  flex-direction: ${({ direction = 'row' }) => direction};
  gap: 0.5rem;
`;

const Club = styled.div`
  font-family: 'PP Neue Montreal Book', sans-serif;
  color: #97969c;
  font-size: 1rem;
  margin: 0 0.5rem;
`;

export type HeaderProps = {
  children?: React.ReactNode;
};

export const Header: React.FC<HeaderProps> = () => {
  const { tournamentId } = useParams<{ tournamentId: string }>();
  const { data } = useGetTournamentQuery({
    variables: { id: tournamentId! },
    skip: !tournamentId,
  });
  return (
    <Container>
      <Flex direction="column">
        <Flex>
          <Order>{data?.tournament.host.slug}</Order>
          <Title>{data?.tournament.name}</Title>
        </Flex>
        <Club>{data?.tournament.host.name}</Club>
      </Flex>
      <Clock className="clock" />
    </Container>
  );
};
